// const CHART_COLORS = [
//   "#FEAD26",
//   "#7E7FD7",
//   "#8ED8B7",
//   "#69B8F4",
//   "#FDE35A",
//   "#C899F4",
//   "#B6BEC7",
//   "#BECFF6",
//   "#D88EAD",
//   "#DCEDC2"
// ];

const CHART_COLORS = [
  "#005FFF", // Theme Blue
  "#6A0DAD", // Violet
  "#512DA8", // Deep Indigo
  "#303F9F", // Indigo
  "#689F38", // Lime-Green
  "#7B1FA2", // Purple
  "#009688", // Teal
  "#0288D1", // Cyan-Blue
  "#1976D2", // Bright Blue
  "#FBC02D", // Yellow
  "#388E3C", // Green
  "#C2185B", // Pink-Red
  "#F57C00", // Orange
  "#E64A19", // Deep Orange
  "#D32F2F", // Red
  
];

module.exports = { CHART_COLORS };
